import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useRef, useState } from "react";
import DatePicker from "@/app/(main)/(club)/mes-clubs/[id]/components/date-picker";
import HocTextInput from "@/components/global/inputs/hoc-text-input";
import TextInput from "@/components/global/inputs/text-input";
import { EventForCalendar } from "@/TS/Interfaces/global_interfaces";
interface DatePickerInputProps {
  loading: boolean;
  register: any;
  event: any;
  arrOfEvents: EventForCalendar[];
  setValue: (name: "dayofmonth", value: string) => void;
}
function DatePickerInput(t0) {
  const $ = _c(21);
  const {
    loading,
    register,
    event,
    arrOfEvents,
    setValue
  } = t0;
  let t1;
  if ($[0] !== loading || $[1] !== register) {
    t1 = HocTextInput(TextInput, loading, register);
    $[0] = loading;
    $[1] = register;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const EnhancedTextInput = t1;
  const [isHere, setIsHere] = useState(false);
  const containerRef = useRef(null);
  let t2;
  let t3;
  if ($[3] !== isHere) {
    t2 = () => {
      if (!isHere) {
        return;
      }
      const handleClickOutside = event_0 => {
        if (containerRef.current && !containerRef.current.contains(event_0.target as Node)) {
          setIsHere(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    };
    t3 = [isHere];
    $[3] = isHere;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = e => {
      e.stopPropagation();
      setIsHere(true);
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== event.startDate) {
    t5 = new Date(event.startDate).toLocaleDateString(undefined, {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric"
    });
    $[7] = event.startDate;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      textTransform: "capitalize"
    };
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== EnhancedTextInput || $[11] !== t5) {
    t7 = <div className="inset-0" onClick={t4}><EnhancedTextInput labelClassName="font-bold" inputClassname="pointer-events-none" defaultValue={t5} needed={false} label="DATE" name="dayofmonth" style={t6} type="selectDate" /></div>;
    $[10] = EnhancedTextInput;
    $[11] = t5;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== arrOfEvents || $[14] !== event || $[15] !== isHere || $[16] !== setValue) {
    t8 = isHere && <div className="right-0 top-[100%] w-3/4  rounded border-grey-light absolute"><DatePicker setValue={setValue} isHere={isHere} setIsHere={setIsHere} event={event} eventArr={arrOfEvents} /></div>;
    $[13] = arrOfEvents;
    $[14] = event;
    $[15] = isHere;
    $[16] = setValue;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t7 || $[19] !== t8) {
    t9 = <div ref={containerRef} className="flex flex-col gap-6 relative">{t7}{t8}</div>;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}
export default DatePickerInput;